import {Injectable} from '@angular/core';
import {GoogleMapsService} from "./google-map.service";
import {Subject} from "rxjs";
import {
  PositionGps
} from "../../classes/common/position-gps";
import {MainMapService} from "src/app/services/common/main-map-service";
import {DataService} from "src/app/services/common/data.service";
import {Waypoint} from "src/app/classes/common/waypoint";
import {MARKER_WITH_DIRECTION} from "src/models/markerSize";
import { Utility } from 'src/app/classes/common/utility';
import {ToastController} from "@ionic/angular";
import {PlanRoute} from "src/app/classes/common/planRoute";
import {ApiService} from "src/app/services/common/api.service";
import {Poi} from "src/app/classes/common/poi";

@Injectable({
  providedIn: 'root'
})
export class PlanRouteService {

  readonly MAP_NAME: string = "history";

  static roadMapLabel: string; // label etichetta read map
  static roadMapImage: string; // Url immagine anteprima road map
  static satelliteMapLabel: string; // label etichetta mappa satellitare
  static satelliteMapImage: string; // Url immagine anteprima mappa satellitare
  static currentMapType:  string;
  static isMobile: boolean;


  lastZoom: number;
  lastCenter: any;

  buttonMapType_1: any;

  poiMarkers: any[] = [];

  constructor(
    public map: MainMapService,
    public googleMaps: GoogleMapsService,
    private data: DataService,
    private toastController: ToastController,
    private api: ApiService
  ) {
  }

  mapType: string;
  mapRoutes: any;
  selectedPositonMarker: any;

  infoWindowNewWaypoint: any;
  infoWindow: any;
  infoWindowPoi: any;
  waypointMarkers: any[] = [];
  coordinates: any[] = [];

  onSelectMarker = new Subject<any>();
  onSelectMarker$ = this.onSelectMarker.asObservable();

  onSelectPosition = new Subject<any>();
  onSelectPosition$ = this.onSelectPosition.asObservable();

  onReset = new Subject<any>();
  onReset$ = this.onReset.asObservable();


  planRoutes: PlanRoute[] = [];

  initMap(
    mapType: string,
    isMobile?: boolean,
    roadMapLabel?: string,
    roadMapImage?: string,
    satelliteMapLabel?: string,
    satelliteMapImage?: string,
  ) {
    PlanRouteService.isMobile = isMobile;
    PlanRouteService.roadMapLabel = roadMapLabel;
    PlanRouteService.roadMapImage = roadMapImage;
    PlanRouteService.satelliteMapLabel = satelliteMapLabel;
    PlanRouteService.satelliteMapImage = satelliteMapImage;
    this.mapType = mapType;

    this.infoWindowNewWaypoint = new GoogleMapsService.google.maps.InfoWindow();
    this.infoWindowNewWaypoint.setContent(document.getElementById("planRoute-infowindow-waypoint") as HTMLElement);

    this.infoWindow = new GoogleMapsService.google.maps.InfoWindow();
    this.infoWindow.setContent(document.getElementById("planRoute-infowindow") as HTMLElement);

    this.infoWindowPoi = new GoogleMapsService.google.maps.InfoWindow();
    this.infoWindowPoi.setContent(document.getElementById("planRoute-infowindow-poi") as HTMLElement);

    switch (this.mapType) {
      case "Google":
        this.initMapGoogle();
        break;
    }
  }

  clearMap(){
    this.removeWaypointMarkers();
    this.selectedPositonMarker = undefined;
  }

  drawWaypointMarker(waypoint: Waypoint, index: number){
    switch (this.mapType) {
      case "Google":
        this.drawSingleWaypointMarkerGoogle(waypoint, index);
        break;
    }
  }

  // Metodo ausiliario per la creazione di un marker di un participant
  private drawSingleWaypointMarkerGoogle(waypoint: Waypoint, index: number){
    if(waypoint.coordinates && waypoint.coordinates.latitude && waypoint.coordinates.longitude){
      const coord: any = {
        lat: waypoint.coordinates.latitude,
        lng: waypoint.coordinates.longitude
      };

      let marker: any = new GoogleMapsService.google.maps.marker.AdvancedMarkerElement({
        zIndex: 200 + index,
        map: this.mapRoutes,
        position: coord,
        content: this.createMarker()
      });
      marker.id = waypoint._id;
      marker.content.querySelector(".mappa_marker").style.backgroundColor = '#309fff';
      marker.content.querySelector(".mappa_v-marker").style.borderTopColor = '#309fff';

      console.log(marker.content);
      const label_elem = marker.content.querySelector(".mappa_label_number");
      label_elem.textContent = index+1;
      label_elem.style.display = 'unset';

      marker.addListener("click", (e: any) => {
        e = e.domEvent;
        e.stopPropagation();
        this.closeInfoWindow();
        let click_in_spider: boolean;
        if(this.googleMaps.markers_in_spider?.find(elem => elem.id === marker.id)){
          click_in_spider = true;
        }
        this.googleMaps.unspiderfyMarkers();
        if(click_in_spider){
          marker.zIndex = 1000;
          this.onSelectMarker.next({type: 'waypoint', id: marker.id, waypoint: waypoint});
          this.infoWindow.open(this.map, marker);
          if(!MainMapService.isMobile) this.infoWindow.open(this.map, marker);
          return;
        }else{
          const clickX = e.clientX;
          const clickY = e.clientY;

          this.googleMaps.markers_in_spider = this.getMarkersAtClick(e);
          if (this.googleMaps.markers_in_spider.length > 1) {
            // include anche il marker cliccato
            if(this.googleMaps.markers_in_spider.length > 12) {
              this.googleMaps.spiderfyMoltiMarkers(clickX, clickY, this.googleMaps.markers_in_spider);
            }else{
              this.googleMaps.spiderfyMarkers(clickX, clickY, this.googleMaps.markers_in_spider);
            }
          } else {
            this.onSelectMarker.next({type: 'waypoint', id: marker.id, waypoint: waypoint});
            this.infoWindow.open(this.map, marker);
            if(!MainMapService.isMobile) this.infoWindow.open(this.map, marker);
          }
        }
      });

      this.waypointMarkers.push(marker);
      this.googleMaps.addMarker(marker, this.MAP_NAME);
    }
  }

  resizeMap(){
    switch (this.mapType) {
      case "Google":
        this.resizeMapGoogle();
        break;
    }
  }

  // Chiude l'infowindow
  closeInfoWindow(){
    switch (this.mapType) {
      case "Google":
        return this.closeInfoWindowGoogle();
    }
  }

  /*** GOOGLE MAPS ***/
  private async initMapGoogle() {
    this.googleMaps.clearMap();
    this.mapRoutes = this.googleMaps.getMap();
    let mapContainer: any = document.getElementById("route-map");
    if(mapContainer){
      mapContainer.appendChild(this.googleMaps.getDivMap());
      this.googleMaps.setCurrentMap(this.MAP_NAME);
    }
    this.mapRoutes.setOptions({
      center: {lat: 44.69, lng: 7.84},
      zoom: 9,
      fullscreenControl: false,
      zoomControl: !PlanRouteService.isMobile,
      streetViewControl: false,
      mapTypeControl: false,
      mapTypeId: PlanRouteService.currentMapType || GoogleMapsService.google.maps.MapTypeId.ROADMAP,
    });
    let boundsChangeListener: any = this.mapRoutes.addListener(this.mapRoutes, 'bounds_changed', () => {
      this.lastZoom = this.mapRoutes.getZoom();
      this.lastCenter = this.mapRoutes.getCenter();
    });
    this.googleMaps.addListener(boundsChangeListener, this.MAP_NAME);

    const listenerRef: any = this.mapRoutes.addListener('rightclick', (event: any) => {
      this.drawSelectMarkerGoogle(event.latLng.lat(), event.latLng.lng());
    });
    this.googleMaps.addListener(listenerRef, this.MAP_NAME);

    let clickListener: any = this.mapRoutes.addListener(this.mapRoutes, 'click', () => {
      this.closeInfoWindowGoogle();
      this.onSelectMarker.next({id: ''});
    });
    this.googleMaps.addListener(clickListener, this.MAP_NAME);

    if(PlanRouteService.roadMapLabel &&
      PlanRouteService.roadMapImage &&
      PlanRouteService.satelliteMapLabel &&
      PlanRouteService.satelliteMapImage){
      this.setMapTypeControls();
    }
  }

  private resizeMapGoogle(){
    if (this.waypointMarkers?.length > 0) {
      let bounds: any = new GoogleMapsService.google.maps.LatLngBounds();

      for (const marker of this.waypointMarkers) {
        bounds.extend(marker.position);
      }

      if(!bounds.isEmpty()){
        this.mapRoutes.fitBounds(bounds);
      }
    }
  }

  private closeInfoWindowGoogle(){
    if(this.infoWindow) this.infoWindow.close();
    if(this.infoWindowPoi) this.infoWindowPoi.close();
    if(this.infoWindowNewWaypoint) this.infoWindowNewWaypoint.close();
    if(this.selectedPositonMarker) this.googleMaps.removeMarker(this.selectedPositonMarker, this.MAP_NAME);
    this.selectedPositonMarker = undefined;
  }

  // Setta il menù con le icone per cambio tipo mappa e infotraffico
  private async setMapTypeControls(){
    const size: string = PlanRouteService.isMobile ? '50px' : '75px';
    if(!this.buttonMapType_1){
      this.buttonMapType_1 = document.createElement('div');
      let controlUIMap = document.createElement('div');
      controlUIMap.style.height = size;
      controlUIMap.style.width = size;
      controlUIMap.style.background = "linear-gradient(0deg,rgba(0,0,0,0.3),rgba(0,0,0,0.3)),url(" + PlanRouteService.satelliteMapImage + ")";
      controlUIMap.style.backgroundSize = size + " " + size;
      controlUIMap.style.border = '2px solid #fff';
      controlUIMap.style.borderRadius = '5px';
      controlUIMap.style.cursor = 'pointer';
      controlUIMap.style.marginRight = PlanRouteService.isMobile ? '8px' : '10px';
      this.buttonMapType_1.style.marginBottom = "5px";
      this.buttonMapType_1.appendChild(controlUIMap);
      let controlTexMap = document.createElement('div');
      controlTexMap.style.color = "#fff";
      controlTexMap.style.fontFamily = 'Roboto,Arial,sans-serif';
      controlTexMap.style.fontSize = PlanRouteService.isMobile ? '8px' : '10px';
      controlTexMap.style.lineHeight = '38px';
      controlTexMap.style.paddingLeft = '5px';
      controlTexMap.style.paddingRight = '5px';
      controlTexMap.style.marginTop = PlanRouteService.isMobile ? '20px' : '40px';
      controlTexMap.style.textOverflow = 'ellipsis';
      controlTexMap.style.overflow = 'hidden';
      controlTexMap.style.whiteSpace = 'nowrap';
      controlTexMap.innerHTML = PlanRouteService.satelliteMapLabel;
      this.buttonMapType_1.addEventListener('click', () => {
        let mapTypeId: string = this.mapRoutes.getMapTypeId();
        if (mapTypeId == GoogleMapsService.google.maps.MapTypeId.HYBRID) {
          controlUIMap.style.background = "linear-gradient(0deg,rgba(0,0,0,0.3),rgba(0,0,0,0.3)),url(" + PlanRouteService.satelliteMapImage + ")";
          controlUIMap.style.backgroundSize = size + " " + size;
          controlTexMap.innerHTML = PlanRouteService.satelliteMapLabel;
          PlanRouteService.currentMapType = GoogleMapsService.google.maps.MapTypeId.ROADMAP;
        } else {
          controlUIMap.style.background = "linear-gradient(0deg,rgba(0,0,0,0.3),rgba(0,0,0,0.3)),url(" + PlanRouteService.roadMapImage + ")";
          controlUIMap.style.backgroundSize = size + " " + size;
          controlTexMap.innerHTML = PlanRouteService.roadMapLabel;
          PlanRouteService.currentMapType = GoogleMapsService.google.maps.MapTypeId.HYBRID;
        }
        this.mapRoutes.setMapTypeId(PlanRouteService.currentMapType);
      });
      controlUIMap.appendChild(controlTexMap);
    }
    this.mapRoutes.controls[GoogleMapsService.google.maps.ControlPosition.RIGHT_BOTTOM].push(this.buttonMapType_1);
  }

  removeWaypointMarkers(){
    switch (this.mapType) {
      case "Google":
        this.cleanWaypointMarkesGoogle();
        break;
    }
  }

  removeWaypointMarker(id: string){
    switch (this.mapType) {
      case "Google":
        return this.removeWaypointMarkerGoogle(id);
    }
  }

  private removeWaypointMarkerGoogle(id: string){
    for(let i=0; i<this.waypointMarkers.length; i++){
      if(this.waypointMarkers[i].id === id){
        this.googleMaps.removeMarker(this.waypointMarkers[i], this.MAP_NAME);
        this.waypointMarkers.splice(i, 1);
        return;
      }
    }
  }

  private cleanWaypointMarkesGoogle(){
    if(this.waypointMarkers){
      for(let marker of this.waypointMarkers){
        this.googleMaps.removeMarker(marker, this.MAP_NAME);
      }
    }
  }

  private drawSelectMarkerGoogle(lat: number, lng: number){
    this.selectedPositonMarker = new GoogleMapsService.google.maps.marker.AdvancedMarkerElement({
      zIndex: 10000,
      map: this.mapRoutes,
      position: {lat: lat, lng: lng},
      content: this.googleMaps.createSelectedMarker()
    });
    this.selectedPositonMarker.id = 'selected-position-marker';

    this.onSelectMarker.next({type: 'selected-position-marker', id: this.selectedPositonMarker.id, position: {lat: lat, lng:lng}});
    this.infoWindowNewWaypoint.open(this.map, this.selectedPositonMarker);

    this.selectedPositonMarker.addListener("click", (e: any) => {
      e = e.domEvent;
      e.stopPropagation();
      this.closeInfoWindow();
      let click_in_spider: boolean;
      if(this.googleMaps.markers_in_spider?.find(elem => elem.id === this.selectedPositonMarker.id)){
        click_in_spider = true;
      }
      this.googleMaps.unspiderfyMarkers();
      if(click_in_spider){
        this.selectedPositonMarker.zIndex = 1000;
        this.onSelectMarker.next({type: 'selected-position-marker', id: this.selectedPositonMarker.id, position: {lat: lat, lng:lng}});
        this.infoWindowNewWaypoint.open(this.map, this.selectedPositonMarker);
        return;
      }else{
        const clickX = e.clientX;
        const clickY = e.clientY;

        this.googleMaps.markers_in_spider = this.getMarkersAtClick(e);
        if (this.googleMaps.markers_in_spider.length > 1) {
          // include anche il marker cliccato
          if(this.googleMaps.markers_in_spider.length > 12) {
            this.googleMaps.spiderfyMoltiMarkers(clickX, clickY, this.googleMaps.markers_in_spider);
          }else{
            this.googleMaps.spiderfyMarkers(clickX, clickY, this.googleMaps.markers_in_spider);
          }
        } else {
          this.onSelectMarker.next({type: 'selected-position-marker', id: this.selectedPositonMarker.id, position: {lat: lat, lng:lng}});
          this.infoWindowNewWaypoint.open(this.map, this.selectedPositonMarker);
        }
      }
    });

    this.googleMaps.addMarker(this.selectedPositonMarker, this.MAP_NAME);
  }

  async showToast(message: string, duration?: number, color?: string){
    const toast = await this.toastController.create({
      message: message,
      duration: duration ? duration : 2000,
      color: color ? color : "success"
    });

    toast.present();
  }

  reset(){
    this.clearMap();
    this.onReset.next({reset: true})
  }

  async getPlanRoutes(skip: number, limit: number){
    return new Promise(async (resolve, reject) => {
      try{
        this.planRoutes = [];
        let res: any = await this.api.getPlanRoutes(this.data.selOrganization.me._id, skip, limit);

        if(res.data){
          for(let plan of res.data){
            this.planRoutes.push(new PlanRoute(plan, {
              getParticipant: this.data.selOrganization.getParticipant.bind(this.data.selOrganization),
              getPoi: this.data.getPoi.bind(this.data)
            }))
          }
        }

        if(!res.has_more){
          return resolve(null);
        }else{
          return resolve(this.getPlanRoutes(skip + res.data.length, limit));
        }
      }catch(err){
        return reject(err);
      }
    })
  }

  fitMapToAllWaypoints() {
    if (!this.mapRoutes || this.waypointMarkers.length === 0) return;

    const bounds = new GoogleMapsService.google.maps.LatLngBounds();

    for (const marker of this.waypointMarkers) {
      bounds.extend(marker.position);
    }

    if (this.waypointMarkers.length === 1) {
      // Solo un marker → centra ma non zoomare troppo
      const pos = this.waypointMarkers[0].position;
      this.mapRoutes.setCenter(pos);
      // this.mapRoutes.setZoom(13); // imposta uno zoom massimo desiderato, es. 13
    } else {
      // Due o più marker → usa fitBounds normalmente
      this.mapRoutes.fitBounds(bounds);
    }
  }

  drawPoiMarkers(pois: Poi[]){
    switch (this.mapType) {
      case "Google":
        this.drawPoiMarkersGoogle(pois);
        break;
    }
  }

  // Inserisce i marker dei POI
  private drawPoiMarkersGoogle(pois: Poi[]){
    this.poiMarkers = [];
    for(let i=0; i<pois.length; i++){
      this.drawSinglePoiMarkerGoogle(pois[i]);
    }
  }

  // Metodo ausiliario per la creazione di un marker poi
  private drawSinglePoiMarkerGoogle(poi: Poi){
    if(poi.position && poi.position.coordinates && poi.position.coordinates.length === 2){
      const coord: any = {
        lat: poi.position.coordinates[1],
        lng: poi.position.coordinates[0]
      };

      let marker: any = new GoogleMapsService.google.maps.marker.AdvancedMarkerElement({
        zIndex: 10000,
        map: this.mapRoutes,
        position: coord,
        content: GoogleMapsService.createPoiMarker(poi)
      });
      marker.id = poi._id;
      marker.type = 'poi';

      // setto immagine se necessario
      const element: any = marker.content.querySelector('.mappa_internal_img');
      if(poi.image){
        element.style.backgroundImage = `url(${poi.image})`;
      }else{
        element.style.backgroundImage = 'none';
      }

      // setto il label number
      const etichetta: any = marker.content.querySelector('.mappa_etichetta_number');
      let label_elem = marker.content.querySelector(".mappa_label_number");
      etichetta.textContent = `${poi.label_number || ''}`;
      label_elem.textContent = `${poi.label_number || ''} `;
      if(!MainMapService.labelVisible || !poi.label_number){
        label_elem.style.display = 'none';
        etichetta.style.display = 'none';
      }else{
        label_elem.style.display = 'block';
        if(poi.image){
          etichetta.style.display = 'block';
        }else{
          etichetta.style.display = 'none';
        }
      }

      marker.addListener("click", (e: any) => {
        e = e.domEvent;
        e.stopPropagation();
        this.closeInfoWindow();
        let click_in_spider: boolean;
        if(this.googleMaps.markers_in_spider?.find(elem => elem.id === marker.id)){
          click_in_spider = true;
        }
        this.googleMaps.unspiderfyMarkers();
        if(click_in_spider){
          marker.zIndex = 1000;
          this.onSelectMarker.next({type: 'poi', id: marker.id, poi: poi._id.toString()});
          if(!MainMapService.isMobile) this.infoWindowPoi.open(this.map, marker);
          return;
        }else{
          const clickX = e.clientX;
          const clickY = e.clientY;

          this.googleMaps.markers_in_spider = this.getMarkersAtClick(e);
          if (this.googleMaps.markers_in_spider.length > 1) {
            // include anche il marker cliccato
            if(this.googleMaps.markers_in_spider.length > 12) {
              this.googleMaps.spiderfyMoltiMarkers(clickX, clickY, this.googleMaps.markers_in_spider);
            }else{
              this.googleMaps.spiderfyMarkers(clickX, clickY, this.googleMaps.markers_in_spider);
            }
          } else {
            this.onSelectMarker.next({type: 'poi', id: marker.id, poi: poi._id.toString()});
            if(!MainMapService.isMobile) this.infoWindowPoi.open(this.map, marker);
          }
        }
      });

      this.poiMarkers.push(marker);
      this.googleMaps.addMarker(marker, this.MAP_NAME);
    }
  }

  removePoiMarkers(){
    switch (this.mapType) {
      case "Google":
        this.cleanPoiMarkesGoogle();
        break;
    }
  }

  private cleanPoiMarkesGoogle(){
    if(this.poiMarkers){
      for(let marker of this.poiMarkers){
        this.googleMaps.removeMarker(marker, this.MAP_NAME);
      }
    }
  }

  private createMarker(){
    // usa le classi di main map, quindi non dobbiamo specificarne altri
    const markerContent = document.createElement("div");
    markerContent.innerHTML = `
<div class="mappa_custom-marker">
  <div class="mappa_marker-scalable">
    <div class="mappa_marker">
      <div class="mappa_label_number"></div>
      <div class="mappa_v-marker-border"></div>
      <div class="mappa_v-marker"></div>
    </div>
  </div>
</div>
`;

    return markerContent.firstElementChild;
  }

  getMarkersAtClick(event) {
    const clickX = event.clientX;
    const clickY = event.clientY;
    const overlappingMarkers = [];

    this.waypointMarkers.forEach(marker => {
      const rect = marker.content.getBoundingClientRect();

      const isClickInside =
        clickX >= rect.left &&
        clickX <= rect.right &&
        clickY >= rect.top &&
        clickY <= rect.bottom;

      if (isClickInside) {
        overlappingMarkers.push(marker);
      }
    });

    this.poiMarkers.forEach(marker => {
      const rect = marker.content.getBoundingClientRect();

      const isClickInside =
        clickX >= rect.left &&
        clickX <= rect.right &&
        clickY >= rect.top &&
        clickY <= rect.bottom;

      if (isClickInside) {
        overlappingMarkers.push(marker);
      }
    });

    return overlappingMarkers;
  }

}
